import React, { Component } from 'react';
import './style.css';



const WriteArea = (props) => {
    const a = props.he

    const divStyle = {
        height: a + 'px',
        minHeight: '100%',
        minHeight:'100vh'
    }

    return (
    <div className='textarea-contain'>
        <textarea style={divStyle} className='textarea' value={props.value} onChange={props.controlFuncs}></textarea>
    </div>
    );
}

export default WriteArea


// WEBPACK FOOTER //
// ./src/components/WriteArea.js